import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MoonStar, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 relative"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1707208097739-e3bdf439acb2?crop=entropy&cs=srgb&fm=jpg&q=85')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-[#090a0f]/90" />
      <form
        onSubmit={submit}
        data-testid="login-form"
        className="relative w-full max-w-sm bg-[#12141d]/95 backdrop-blur-xl border border-[#3b4259] rounded-lg p-8 shadow-2xl animate-fade-up"
      >
        <div className="flex items-center gap-3 mb-2">
          <MoonStar className="w-7 h-7 text-[#8b5cf6]" />
          <div>
            <h1 className="text-xl font-extrabold tracking-tight">Observatorio</h1>
            <div className="text-[10px] font-mono2 uppercase tracking-widest text-slate-500">Nightlife Milano</div>
          </div>
        </div>
        <p className="text-xs text-slate-500 mb-6 mt-3">Acceso privado — base de datos de investigación</p>

        <label className="block text-xs font-mono2 uppercase tracking-widest text-slate-400 mb-1.5">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="login-email-input"
          className="w-full bg-[#090a0f] border border-[#232838] rounded-md px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#8b5cf6] transition-colors mb-4"
          placeholder="tu@email.com"
        />
        <label className="block text-xs font-mono2 uppercase tracking-widest text-slate-400 mb-1.5">Contraseña</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="login-password-input"
          className="w-full bg-[#090a0f] border border-[#232838] rounded-md px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#8b5cf6] transition-colors mb-5"
          placeholder="••••••••"
        />

        {error && (
          <div data-testid="login-error" className="mb-4 text-xs text-red-400 bg-red-950/40 border border-red-900 rounded-md px-3 py-2">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit-button"
          className="w-full bg-[#8b5cf6] hover:bg-[#7c3aed] disabled:opacity-50 text-white text-sm font-semibold rounded-md py-2.5 transition-colors flex items-center justify-center gap-2"
        >
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          Entrar
        </button>
      </form>
    </div>
  );
}
